// import React, { useState } from "react";
// import "../../Style/Pages/Header.css";
// import logo from '../../Assest/logo.png';
// import { Link, useNavigate } from "react-router";
// const Header = () => {
//     const [menuOpen, setMenuOpen] = useState(false);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [nestedOpen, setNestedOpen] = useState(false);
//     const navigate = useNavigate();
//     const closeMenus = () => {
//         setDropdownOpen(false);
//         setNestedOpen(false);
//         setMenuOpen(false);
//     };
//     const handleFormLinkClick = (formType) => (e) => {
//         e.preventDefault();
//         closeMenus();
//         navigate(`/Auth?formType=${formType}`);
//     };
//     return (
//         <nav className="navbar" id="header">
//             <div className="navbar-container">
//                 <div className='header-logo'>
//                     <li className='head-item-img'><img src={logo} width={100} /></li>
//                     <li>
//                         <h1 className='logo-name'>AMIGO MATH</h1>
//                         <p>calculating success together</p>
//                     </li>
//                 </div>

//                 <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
//                     <li className="nav-item">
//                         <Link to="/" className="nav-link" onClick={closeMenus}>Home</Link>
//                     </li>

//                     <li className="nav-item">
//                         <a href="#whyUs" className="nav-link" onClick={closeMenus}>Why US</a>
//                     </li>

//                     <li className="nav-item">
//                         <a href="#courses" className="nav-link" onClick={closeMenus}>Courses</a>
//                     </li>
//                     <li
//                         className="nav-item nav-dropdown"
//                         onMouseEnter={() => setDropdownOpen(true)}
//                         onMouseLeave={() => setDropdownOpen(false)}
//                         onClick={() => setDropdownOpen(!dropdownOpen)}
//                     >
//                         <li className="nav-link">Online Training</li>
//                         <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
//                             {/* Add/Sub */}
//                             <li className="nav-dropdown" onMouseEnter={() => setNestedOpen(true)} onMouseLeave={() => setNestedOpen(false)} >
//                                 <p className="nav-link">Add/Sub</p>
//                                 <ul className={`nested-menu ${nestedOpen ? "show1" : ""}`}>
//                                     <p> <Link className="nav-link dropdown-list" to="/additionGenrator" onClick={handleFormLinkClick('additionGenrator')}>Generator</Link></p>
//                                     <p><Link to='additionFlash' className="nav-link dropdown-list" onClick={closeMenus}>Flash</Link></p>
//                                     <p><Link to='additionSet' className="nav-link dropdown-list" onClick={closeMenus}>Set</Link></p>
//                                 </ul>
//                             </li>
//                             {/* Division */}
//                             <li
//                                 className="nav-dropdown"
//                                 onMouseEnter={() => setNestedOpen(true)}
//                                 onMouseLeave={() => setNestedOpen(false)}
//                             >
//                                 <p className="nav-link">Division</p>
//                                 <ul className={`nested-menu ${nestedOpen ? "show1" : ""}`}>
//                                     <p><Link to="divisonGenrator" className="nav-link dropdown-list" onClick={closeMenus}>Generator</Link></p>
//                                     <p><Link to='divisonSet' className="nav-link dropdown-list" onClick={closeMenus}>Set</Link></p>
//                                     <p><Link to='divisonSpeedRound' className="nav-link dropdown-list" onClick={closeMenus}>SpeedRound</Link></p>
//                                 </ul>
//                             </li>
//                             {/* Multiplication */}
//                             <li
//                                 className="nav-dropdown"
//                                 onMouseEnter={() => setNestedOpen(true)}
//                                 onMouseLeave={() => setNestedOpen(false)}
//                             >
//                                 <p className="nav-link">Multiplication</p>
//                                 <ul className={`nested-menu ${nestedOpen ? "show1" : ""}`}>
//                                     <p><Link to="multiplicationGenrator" className="nav-link dropdown-list" onClick={closeMenus}>Generator</Link></p>
//                                     <p><Link to="multiplicationSet" className="nav-link dropdown-list" onClick={closeMenus}>Set</Link></p>
//                                     <p><Link to="multiplicationSpeedRound" className="nav-link dropdown-list" onClick={closeMenus}>SpeedRound</Link></p>
//                                 </ul>
//                             </li>
//                         </ul>
//                     </li>
//                     <li>
//                         <Link className='contact-us' to="contact" onClick={closeMenus}>Contact us</Link>
//                     </li>
//                 </ul>
//                 <button
//                     className={`menu-icon ${menuOpen ? "active" : ""}`}
//                     onClick={() => setMenuOpen(!menuOpen)}
//                 >
//                     ☰
//                 </button>
//             </div>
//         </nav>
//     );
// };

// export default Header;











import React, { useState } from "react";
import "../../Style/Pages/Header.css";
import logo from '../../Assest/logo.png';
import { Link, useNavigate } from "react-router";
import Cookies from "js-cookie";

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [nestedOpen, setNestedOpen] = useState(false);
    const navigate = useNavigate();

    const closeMenus = () => {
        setDropdownOpen(false);
        setNestedOpen(false);
        setMenuOpen(false);
    };

    const handleFormLinkClick = (formType) => (e) => {
        e.preventDefault();
        closeMenus();
        navigate(`/Auth?formType=${formType}`);
    };

    const handleOnlineTrainingClick = () => {
        const isLoggedIn = Cookies.get('pin-verified') === 'true';
        if (!isLoggedIn) {
            closeMenus();
            navigate('/Auth?formType=additionGenrator'); // or a generic login page
        } else {
            setDropdownOpen(!dropdownOpen);
        }
    };

    return (
        <nav className="navbar" id="header">
            <div className="navbar-container">
                <div className='header-logo'>
                    <li className='head-item-img'><img src={logo} width={100} /></li>
                    <li>
                        <h1 className='logo-name'>AMIGO MATH</h1>
                        <p>calculating success together</p>
                    </li>
                </div>

                <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
                    <li className="nav-item">
                        <Link to="/" className="nav-link" onClick={closeMenus}>Home</Link>
                    </li>
                    <li className="nav-item">
                        <a href="../#whyUs" className="nav-link" onClick={closeMenus}>Why US</a>
                    </li>
                    <li className="nav-item">
                        <a href="../#courses" className="nav-link" onClick={closeMenus}>Courses</a>
                    </li>

                    <li
                        className="nav-item nav-dropdown"
                        onMouseEnter={() => {
                            if (Cookies.get('pin-verified') === 'true') setDropdownOpen(true);
                        }}
                        onMouseLeave={() => {
                            if (Cookies.get('pin-verified') === 'true') setDropdownOpen(false);
                        }}
                        onClick={handleOnlineTrainingClick}
                    >
                        <li className="nav-link">Online Training</li>

                        {Cookies.get('pin-verified') === 'true' && (
                            <ul className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}>
                                {/* Add/Sub */}
                                <li
                                    className="nav-dropdown"
                                    onMouseEnter={() => setNestedOpen(true)}
                                    onMouseLeave={() => setNestedOpen(false)}
                                >
                                    <p className="nav-link">Add/Sub</p>
                                    <ul className={`nested-menu ${nestedOpen ? "show1" : ""}`}>
                                        <p>
                                            <Link className="nav-link dropdown-list" to="/additionGenrator" onClick={handleFormLinkClick('additionGenrator')}>Generator</Link>
                                        </p>
                                        <p>
                                            <Link to='additionFlash' className="nav-link dropdown-list" onClick={closeMenus}>Flash</Link>
                                        </p>
                                        <p>
                                            <Link to='additionSet' className="nav-link dropdown-list" onClick={closeMenus}>Set</Link>
                                        </p>
                                        <p>
                                            <Link to='nocombination' className="nav-link dropdown-list" onClick={closeMenus}>No combination</Link>
                                        </p>
                                    </ul>
                                </li>

                                {/* Division */}
                                <li
                                    className="nav-dropdown"
                                    onMouseEnter={() => setNestedOpen(true)}
                                    onMouseLeave={() => setNestedOpen(false)}
                                >
                                    <p className="nav-link">Division</p>
                                    <ul className={`nested-menu ${nestedOpen ? "show1" : ""}`}>
                                        <p>
                                            <Link to="divisonGenrator" className="nav-link dropdown-list" onClick={closeMenus}>Generator</Link>
                                        </p>
                                        <p>
                                            <Link to='divisonSet' className="nav-link dropdown-list" onClick={closeMenus}>Set</Link>
                                        </p>
                                        <p>
                                            <Link to='divisonSpeedRound' className="nav-link dropdown-list" onClick={closeMenus}>SpeedRound</Link>
                                        </p>
                                    </ul>
                                </li>

                                {/* Multiplication */}
                                <li
                                    className="nav-dropdown"
                                    onMouseEnter={() => setNestedOpen(true)}
                                    onMouseLeave={() => setNestedOpen(false)}
                                >
                                    <p className="nav-link">Multiplication</p>
                                    <ul className={`nested-menu ${nestedOpen ? "show1" : ""}`}>
                                        <p>
                                            <Link to="multiplicationGenrator" className="nav-link dropdown-list" onClick={closeMenus}>Generator</Link>
                                        </p>
                                        <p>
                                            <Link to="multiplicationSet" className="nav-link dropdown-list" onClick={closeMenus}>Set</Link>
                                        </p>
                                        <p>
                                            <Link to="multiplicationSpeedRound" className="nav-link dropdown-list" onClick={closeMenus}>SpeedRound</Link>
                                        </p>
                                    </ul>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li>
                        <a className='contact-us' href="../#contact" onClick={closeMenus}>Contact us</a>
                    </li>
                </ul>

                <button
                    className={`menu-icon ${menuOpen ? "active" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    ☰
                </button>
            </div>
        </nav>
    );
};

export default Header;
